import type { WorkspaceDefinition } from '@/core/ui/workspace'

// docs/upgrade/06 §4 nhóm Mua hàng (đợt M3). Đăng ký tài sản mở cho mọi tài khoản đăng nhập như trước.
const procurement = () => import('@/modules/procurement/ProcurementWorkspaceView.vue')

export const procurementWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'requests', labelKey: 'nav.purchaseRequests', icon: 'pi pi-shopping-cart', permission: 'PurchaseRequests.Read', component: procurement, props: { mode: 'requests' } },
    { key: 'orders', labelKey: 'nav.purchaseOrders', icon: 'pi pi-file', permission: 'PurchaseOrders.Read', component: procurement, props: { mode: 'orders' } },
  ],
}

export const warehouseWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'stock', labelKey: 'nav.assetStock', icon: 'pi pi-warehouse', permission: 'MaterialStock.Read', component: () => import('@/modules/procurement/AssetMaterialStockView.vue') },
    { key: 'inventory', labelKey: 'procurement.inventory.title', icon: 'pi pi-list-check', permission: 'MaterialStock.Read', component: () => import('@/modules/procurement/MaterialInventoryView.vue') },
    { key: 'registrations', labelKey: 'nav.assetRegistrations', icon: 'pi pi-box', component: () => import('@/modules/workforce/EnrollProcurementMaterialView.vue') },
  ],
}
